import { STAFF_OR_ABOVE, SUPER_ADMIN_ONLY, UserRole } from "@excel-center/shared";

/** Childcare section (attendance, children, reports) — staff with access + admins. */
export const CHILDCARE_STAFF_ROLES = STAFF_OR_ABOVE;

/** Terms management (shared platform config). */
export const CHILDCARE_ADMIN_ROLES = SUPER_ADMIN_ONLY;

/** Parent surface ("Childcare") in the student portal. */
export const CHILDCARE_PARENT_ROLES = [UserRole.STUDENT] as const;

export const CHILDREN_PAGE_SIZE = 25;

/** Hard limit for the back-dated check-out correction note (client + DB CHECK). */
export const CHECKOUT_NOTE_MAX = 25;
